import { EColorVariablesV2 } from '@/types/theme-packs.types';
import getThemeColorContrastCSSVariable from '@/utils/colors/get-theme-color-contrast-css-variable';
import getThemeColorCSSVariable from '@/utils/colors/get-theme-color-css-variable';
import Button from '@ui/buttons/button/button';
import Container from '@ui/container/container';
import Modal from '@ui/modal/modal';
import Text from '@ui/text/text/text';

type ConfirmationModalProps = {
  showModal: boolean;
  heading: string;
  content: string;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  onPrimaryAction: () => void;
  onSecondaryAction: () => void;
};

export function ConfirmationModal({
  showModal,
  heading,
  content,
  primaryButtonText = 'Confirm',
  secondaryButtonText = 'Cancel',
  onPrimaryAction,
  onSecondaryAction,
}: ConfirmationModalProps) {
  return (
    <Modal
      open={showModal}
      customSize={{
        width: '440px',
        height: 'auto',
        maxHeight: '300px',
        minHeight: '200px',
        maxWidth: 'calc(100vw - 80px)',
      }}
      showBackdrop
      contentWrapperClassName="padding-v-24 padding-h-40 gap-10"
      RenderHeaderContent={() => (
        <Container className="radius-10">
          <Text clamp={2} whiteSpace="wrap" tag="h4" color="var(--gray-100)" className="H4 margin-b-8">
            {heading}
          </Text>
        </Container>
      )}
      RenderFooterContent={() => (
        <Container borderRadius="0 0 12px 12px" className="flex fd-row jc-flex-end ai-center gap-16">
          <button
            type="button"
            className="L1 padding-v-16 padding-h-16 flex ai-center gap-6"
            onClick={onSecondaryAction}
          >
            {secondaryButtonText}
          </button>
          <Button
            backgroundColor={getThemeColorCSSVariable()}
            width="fit-content"
            className="L1 padding-v-16 padding-h-16"
            onClick={onPrimaryAction}
          >
            <Text
              color={getThemeColorContrastCSSVariable(EColorVariablesV2.buttonText, EColorVariablesV2.primary)}
              className="L1"
            >
              {primaryButtonText}
            </Text>
          </Button>
        </Container>
      )}
    >
      <Container className="overflow-auto" height="100%">
        <Text tag="p" color="var(--gray-300)" className="P1">
          {content}
        </Text>
      </Container>
    </Modal>
  );
}
